import { render, staticRenderFns } from "./Motion.vue?vue&type=template&id=1bb0f923&"
import script from "./Motion.vue?vue&type=script&lang=js&"
export * from "./Motion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports